<template>
	<section class="custom-chat" v-if="getTemCurrentConversa">
		<div class="mensagens" ref="msgContainer">
			<item-mensagen
				v-for="(msgItem, index) in getCurrentConversa" :key="'item-mensagen-'+index"
				:avatar="msgItem.avatar" :is-proprio="msgItem.isProprio" :data="msgItem.data" :mensagem="msgItem.mensagem"
			></item-mensagen>
			{{ scrollMsg() }}
		</div>
		<div class="text-area">
			<textarea class="form-control" v-model="msg" @keydown.enter.exact.prevent
					  @keyup.enter.exact="addCurrMsg()" name="mensagemNew" placeholder="Digite sua Mensagem"></textarea>
			<button class="btn btn-primary button-send-absolut" type="button" @click.prevent="addCurrMsg()"><i class="fas fa-paper-plane"></i></button>
			<div class="btn-group dropup" style="display: none;">
				<button disabled type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					Mensagens Pré Programadas
				</button>
				<div class="dropdown-menu" >
					<button class="dropdown-item" @click="addMsg('Me passa os seguintes dados pessoais: Nome / RG / CPF / Data de Nasc. / Fone / E-mail')">Dados Pessoais ?</button>
					<button class="dropdown-item" @click="addMsg('Seu Endereço ?')">Seu Endereço ?</button>
					<button class="dropdown-item" @click="addMsg('O plano que tem interesse ?')">O plano que tem interesse ?</button>
					<button class="dropdown-item" @click="addMsg('Vai querer ponto adicional ?')">Vai querer ponto adicional ?</button>
					<button class="dropdown-item" @click="addMsg('Possui outra operadora ?')">Possui outra operadora ?</button>
					<button class="dropdown-item" @click="addMsg('Qual operadora ?')">Qual operadora ?</button>
				</div>
			</div>

			<button class="btn btn-danger chatMensagem-button" type="button" @click.prevent="endCurrChat()">Finalizar</button>
			<button class="btn cadastrar chatMensagem-button" type="button" @click.prevent="cadastrar()">Cadastrar</button>
		</div>
	</section>
	<div v-else>

	</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import ItemMensagen from "./ItemMensagen";
import swal from 'sweetalert';


import select2 from 'select2'
import $ from 'jquery';

import axios from 'axios';
const dateTimeFormat = new Intl.DateTimeFormat('pt-br', { year: 'numeric', month: '2-digit', day: '2-digit' , hour: 'numeric', minute: 'numeric'});
export default {
	name: "ChatMensagem",
	data: () => ({
		msg: "",
		options: ""
	}),
	components: {ItemMensagen, ...mapGetters(['getCurrentConversa', 'getOptions'])},
	methods: {
		...mapMutations(['addMensagemCurrentConversa', 'endCurrentConversa', 'transfCurrentConversa', 'transfProcess']),
		...mapActions(['optionshareOperator','setModalCadastro']),
		addMsg(txt) {
			if (!txt) {
				return;
			}
			this.addMensagemCurrentConversa({
				isProprio: true,
				data: dateTimeFormat.format(new Date()),
				mensagem: txt,
			})
			
			this.clearMsg();
			this.scrollMsg();
		},
		clearMsg() {
			this.msg = '';
		},
		scrollMsg() {
			requestAnimationFrame(
				() => this.$refs.msgContainer.scrollTop = this.$refs.msgContainer.scrollHeight
			);
		},
		addCurrMsg() {
			this.addMsg(this.msg);
		},

		endCurrChat(){
				this.alertEndChat(this.options);
		},
		alertEndChat(options){
			Swal.fire({
				title: "Finalizar atendimento",
				text: "Tem certeza que deseja finalizar o atendimento?",
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: '#DD6B55',
				confirmButtonText: 'Finalizar',
				cancelButtonText: 'Cancelar',
			})
			.then((willDelete) => {
				console.log(willDelete);
				if (willDelete.value) {
					var produto = $(".asd :selected").map(function() { return $(this).val(); }).get();
					 $('.asd').val('-1').trigger('change');
					this.endCurrentConversa(produto);
					swal("Atendimento finalizado com sucesso", {
						icon: "success",
					});
				} 
			});
		},
		cadastrar(){
	
			this.setModalCadastro();

		}
	},
	computed: {
		...mapGetters(['getTemCurrentConversa', 'getCurrentConversa', 'getCurrentConversaIndex']),
	},
	watch: {
		getCurrentConversaIndex() {
			this.scrollMsg();
		},
		getOptions(){
			console.log('recebi options');
		}
	},
	mounted(){
		this.optionshareOperator();
	}
}
</script>

<style>
	.select2-dropdown {
		z-index: 9001;
	}
	.custom-chat {
		display: flex;
		flex-direction: column;
	}
	.text-area {
        height: 3em;
        display: flex;
        margin-top: 1em;
        margin-left: 1em;
        margin-right: 2em;
        margin-bottom: 0.5em;
	}
	.mensagens {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow-y: auto;
	}
</style>
<style scoped>
    .form-control{
        border-radius: 0.5em 0.5em 0.5em 0.5em !important;
        /*border-radius: 1em 1em 1em 1em !important;*/
        margin-right: 1em;
        resize: none;
    }
    img{
        width: 130%;
    }
	.cadastrar{
		background-color: #27ae60;
		color: white;
	}
    .button-send-absolut{
        position: absolute;
        right: 15em;
        bottom: 10px;
        border-radius: 50% !important;
        background-color: rgba(0,0,0,0);
        color: #1c869a !important;
        border: none;
    }
    .chatMensagem-button{
        border-radius: 0.25em !important;
        margin-right: 0.25em;
    }
</style>
